import React, { useEffect, useState, useRef, useCallback, useImperativeHandle, dispatch, forwardRef, useMemo, useContext, } from 'react';
import { isNotValidNullUndefile } from '../control/Constant';
import moment from 'moment';

const CommonTable = ({paymentTableData,openModal,selectedUserData,sessionsData,setSessionsData,setPaymentTableData,setOpenModal,setLoader,sepratepayment,setPayremaningModal,payremaningModal,setSepratepayment,setLastIndex,refrencepage,AssigneeList,show,hide,getFormattedDateForCE}) => {


    const json = {
      userAuthSubId: 0,
      userId: "",
      authSubscriptionId: "",
      cutomerProfileId: "",
      paymentProfileId: "",
      subscriptionId: "",
      subscriptionName: "",
      totalOccurrence: '',
      authLength: "",
      authUnit: "",
      authSubsStartDate: "",
      authSubsEndDate: "",
      totalAmount:"",
      totalDiscount: 0,
      paymentType: '',
      notes: "",
      isActive: true,
      isDelete: false,
      upsertedBy: "",
      authSubsInstallments: [
        {
          authSubInstallmentId: 0,
          orderId: 0,
          payAmount: 0,
          payAmountDate: new Date().toISOString(),
          notes: "",
          isActive: true
        }
      ]
    };
    const paymentJson = {
      productName : null,
      productPrice :null,
      paymentTypeId :null

    }
    const remaningPaymentJson = {
      productPrice :null,
      paymentTypeId :null,
      notes: ""

    }

  const formatPhoneNumber = (mobileNumber) => {
    const contactNumber = mobileNumber;
    function formatPhoneNumber(str) {
      let cleaned = ("" + str).replace(/\D/g, "");

      if (cleaned?.startsWith("254")) {
        return ` ${cleaned?.slice(3, 6) + " " + cleaned?.slice(6, 9) + " " + cleaned?.slice(9)}`
      }
      else {
        let contactNumber = cleaned?.slice(-10)
        let match = contactNumber?.match(/^(\d{3})(\d{3})(\d{4})$/);
        if (match) {
          return "(" + match[1] + ") " + match[2] + "-" + match[3];
        }
        return null;
      }
    }
    if (contactNumber) {
      if (contactNumber?.slice(0, 3) == +91) {
        return contactNumber?.slice(0, 3) + formatPhoneNumber(contactNumber)
      }
      else if (contactNumber?.slice(0, 4) == +254) {
        return contactNumber?.slice(0, 4) + formatPhoneNumber(contactNumber)
      }
      else {
        return contactNumber?.slice(0, 2) + formatPhoneNumber(contactNumber)
      }
    }
    else {
      return ""
    }
  }

  // const getFormattedDateForCE = (value)=> {
  //   return moment(value).format('MM/DD/YYYY');
  // }
  
  const getFormattedUTCDateForCE = (value, zone = "America/New_York") => {
  if (!value) return '';

  const dateStr = String(value);

  const isMidnightUTC = dateStr.endsWith('T00:00:00') || dateStr.endsWith('T00:00:00');

  if (isMidnightUTC) {
    return moment.utc(value).format("MM/DD/YYYY");
  }

  // Otherwise, convert to the specified US timezone
  return moment.utc(value).tz(zone).format("MM/DD/YYYY");
  };

  const table1Res2 = ["serviceMatNo","originatingAttorney","responsibleAttorney","subscriptionName",
    "totalAmount","installmentAmount","installmentStartDate","authLength","notes"];
  const headers2 = ["Matter No","Originating Attorney","Responsible Attorney","Services Name","Signed Amount1"
    ,"Installment Amount","Installment start on","Installment Frequencies","Note"];
  const headers3 = ["Amount","Pay Date","Payment Type","Status","Notes"];
  const table1Re3 = ["payAmount","payAmountDate","paymentType","Status","notes"];



const tableHeader = ["Matter No","Originating / Responsible Attorney","Services Name","Source Type","Signed Amount","Pending Amount","Installment Amount",'General/IOLTA',"Pay Date","Payment Type","Status","Notes"]




  const [header, setheader] = useState(tableHeader)
  const [mapTable, setMapTable] = useState(table1Res2)
  const [tableData, setTableData] = useState()
  const [previewIndex, setpreviewIndex] = useState(0)
  const [previesData, setPreviesData] = useState()
  let [newtableData, setNewtableData] = useState()
  const [lastIndexData, setlastIndexData] = useState()
  const [formData, setFormData] = useState(json)
  const [radioSections, setRadioSections] = useState()
  const [advancePay, setAdvancePay] = useState()
  const [installmentData, setInstallmentData] = useState()
  const [weekDays, setWeekDays] = useState()
  const [paymentType, setPaymentType] = useState()
  const [errors, setErrors] = useState({});
  const [error, setError] = useState({});
  const [error1, setError1] = useState({});
  const [orderIdData, setOrderIdData] = useState()
  const loggedInUserId = sessionStorage.getItem('loggedUserId')
  const [isFuturePay, setisFuturePay] = useState(false)
  const [paymanetForm, setPaymanetForm] = useState(paymentJson)
  const [installmentPayament, setinstallmentPayment] = useState(remaningPaymentJson)
  const [remaningAmout, setRemaningAmout] = useState(0)
  const [originatingVal, setOriginatingVal] = useState()
  const [responsibleVal, setResponsibleVal] = useState()





useEffect(() => {
  if (isNotValidNullUndefile(paymentTableData?.clientAuthSubsVMs)) {
    const data = [...paymentTableData.clientAuthSubsVMs]; // shallow copy (safe)
    const sorted = data.sort((a, b) => {
      return new Date(a.installmentStartDate) - new Date(b.installmentStartDate);
    });
    setTableData(sorted); // This is your new sorted JSON
  }
}, [paymentTableData]);


function formatToUSNew(value) {
    // console.log(value,"valuevaluevaluevaluevalue")
    if (!value) return "";
    let cleaned = value?.replace(/,/g, "");

    if (!/^\d*\.?\d{0,2}$/.test(cleaned)) {
      return null;
    }

    const parts = cleaned.split(".");
    let integerPart = parts[0];
    const decimalPart = parts[1] !== undefined ? parts[1] : null;

    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    if (decimalPart === null) {
      return integerPart;
    } else {
      return integerPart + "." + decimalPart;
    }
  }
//   function formatUSNumber(value) {
//   if (typeof value !== 'number' || isNaN(value)) {
//     return '';
//   }
//   return value.toLocaleString('en-US', {
//     minimumFractionDigits: 2,
//     maximumFractionDigits: 2
//   });
// }




function getValueFromKey(row, key) {


    if (key == "clientPhone") {
      return formatPhoneNumber(row[key]);
    }
    if (["authSubsStartDate","payAmountDate","installmentStartDate"].includes(key)) {
      return isNotValidNullUndefile(row[key]) ? getFormattedUTCDateForCE(row[key]) : "-";
    }
    if (["payAmount","installmentAmount","totalAmount"].includes(key)) {
      const num = row[key] ? row[key].toFixed(2) : ""
      console.log("dskfjadsfhkdjhfakjs",typeof(num))
      return (row[key]) ? `$${formatUSNumber(num)}` : "-";
    }
    if (["authLength"].includes(key)) {
      return isNotValidNullUndefile(row[key]) ?  getTimePeriodLabel(row[key],row["authUnit"]) : "-";
    }
    if (["responsibleAttorney"].includes(key)) {
      return  row?.responsibleAttorneyName || '-'
      //  AssigneeList?.some((a) => a.userId == row[key])
      //                             ? row?.legalUserName
      //                             : "-"
                         }
    if (["originatingAttorney"].includes(key)) {
      return   row?.originatingAttorneyName || '-'
      // AssigneeList?.some((a) => a.userId == row[key])? row?.originatingAttorneyName
      //                             : "-"
    }
    if (key == "paymentType") {
      return row[key] == 1 ? "Card" : row[key] == 2  ? "Cash" : row[key];
    }
    if (key == "serviceMatNo") {
      return isNotValidNullUndefile(row[key]) ? row[key] : paymentTableData?.matNo || "-";
    }
    if (key == "totalOccurrence") {
      return isNotValidNullUndefile(row[key]) && row[key] !== 0 ? (row[key] == 9999 ? "Annually" : row[key]) : "Paid in full (one-time)";
    }

    // If key ends with ".length", return the length of the base property
    if (key.endsWith(".length")) {
      const baseKey = key.split(".")[0];
      return row[baseKey]?.length ?? 0;
    }

    // Otherwise, resolve nested property
    return key.split(".").reduce((acc, part) => acc?.[part], row) ?? "-";
  }



  function getTimePeriodLabel(days,unit) {

    if(unit == 'days'){
        if (days == 7) {
          return "Weekly";
        } else if (days == 30) {
          return "Monthly";
        } else if (days == 365) {
          return "Yearly";
        }else if (days == 91) {
          return "Quarterly";
        }else if (days == 182) {
          return "Half-yearly";
        } else {
          return isNotValidNullUndefile(days) ? `${days} days` : null;
        }
        }else if(unit == 'months'){
            if(days == 1){
              return "Monthly";
            }else if(days == 3){
              return "Quarterly";
            }else if(days == 6){
              return "Half-yearly";
            }else if(days == 12){
             return "Yearly";
            }
        }
  }

// console.log("previewIndex",previewIndex)


    const handleChange = (json, isIncrease, index) => {

        if(previewIndex == 1 && isIncrease === "yes") {
            return;
        }

        setError()
        setError1()
        setErrors()

        if (payremaningModal) return setPayremaningModal(false);
        if (openModal) return setOpenModal(false);
        if (sepratepayment) return setSepratepayment(false);

        const maxIndex = 1;
        const nextIndex = Math.max(0, Math.min(previewIndex + (isIncrease === "yes" ? 1 : -1), maxIndex));
        setpreviewIndex(nextIndex);
        setLastIndex(nextIndex)
        if (previewIndex == nextIndex) {
            hide(false)
            return
        };
        switch (nextIndex) {
            case 0:
                setTableView(headers2, table1Res2, previesData,nextIndex);
                break;
            case 1:
                setTableView(headers3, table1Re3, handleStep2Data(json, index, tableData),nextIndex);
                break;
        }
    };


    const returnStartDate = (json,index,type) => {
        const { installmentStartDate, authUnit, authLength,clientAuthInsVMs } = json;
        const startDate = new Date(installmentStartDate);
        const length = parseInt(authLength);
         console.log("dkjhdkafhdkjf",json,type)
        const filteredJson = clientAuthInsVMs.filter((ele)=>ele?.isScheduledPayment !== false)
        if (authUnit === "days") {
                if(type == 'addIndex'){
                  // const next = (clientAuthInsVMs.length == 0 || filteredJson.length == 0)?  new Date(startDate.getTime()) :  new Date(startDate.getTime() + length * index * 24 * 60 * 60 * 1000);
                  const next =  new Date(startDate.getTime() + length * index * 24 * 60 * 60 * 1000);
                   return isNaN(next.getTime()) ? startDate.toISOString() : next.toISOString();
                }else{
                 const next = (clientAuthInsVMs.length == 0 || filteredJson.length == 0) ?  new Date(startDate.getTime()) :  new Date(startDate.getTime() + length * 24 * 60 * 60 * 1000);
                   return isNaN(next.getTime()) ? startDate.toISOString() : next.toISOString();
                }
        }

        if (authUnit === "months") {
            const updatedDate = new Date(startDate);

            if (length === 12) {
                updatedDate.setFullYear(updatedDate.getFullYear() + index);
            }

            else if (length < 12) {
                const originalDay = updatedDate.getDate();
                updatedDate.setMonth(updatedDate.getMonth() + length * index);

                // Fix case where months don't have the original day (e.g., Feb 31 → Mar 2)
                if (updatedDate.getDate() < originalDay) {
                    updatedDate.setDate(0); // last day of previous month
                }
            }

            // return (clientAuthInsVMs.length == 0 || filteredJson.length == 0) ?  new Date(startDate.getTime()).toISOString() :  updatedDate.toISOString();
            return  updatedDate.toISOString();
        }

        return startDate.toISOString(); // fallback
    }
    const returnStartDate99 = (json,data) => {
        const {authUnit, authLength,clientAuthInsVMs } = json;
        const { payAmountDate } = data;
        const startDate = new Date(payAmountDate);
        const length = parseInt(authLength);

        if (authUnit === "days") {
            // Add (length * index) days
            return  clientAuthInsVMs.length == 0 ?  new Date(startDate.getTime()).toISOString() :  new Date(startDate.getTime() + length * 24 * 60 * 60 * 1000).toISOString();
        }

        if (authUnit === "months") {
            const updatedDate = new Date(startDate);
            if (length === 12) {
                updatedDate.setFullYear(updatedDate.getFullYear() + 1);
            }

            else if (length === 1) {
                const originalDay = updatedDate.getDate();
                updatedDate.setMonth(updatedDate.getMonth());

                // Fix case where months don't have the original day (e.g., Feb 31 → Mar 2)
                if (updatedDate.getDate() < originalDay) {
                    updatedDate.setDate(0); // last day of previous month
                }
            }
            return clientAuthInsVMs.length == 0 ?  new Date(startDate.getTime()).toISOString() :  updatedDate.toISOString();
        }

        return startDate.toISOString(); // fallback
    }



  const createIntalments = (json) => {
    const { clientAuthInsVMs, totalOccurrence, authSubscriptionId } = json
    if (isNotValidNullUndefile(authSubscriptionId)) {
      let totalInstalment = totalOccurrence - clientAuthInsVMs.length
      let newData = [...json?.clientAuthInsVMs]


      let jsonData = {
        "createdBy": null,
        "updatedBy": null,
        "createdOn": "0001-01-01T00:00:00",
        "updatedOn": "0001-01-01T00:00:00",
        "authSubInstallmentId": 0,
        "orderId": 0,
        "payAmount": null,
        "payAmountDate": null,
        "notes": null,
        "isActive": null,
        "Status": 'Paid'
      }
      if (totalOccurrence == 9999) {
        Array().fill().forEach(() => newData.push({ ...jsonData }));
        newData = newData.map((e) => { return { ...e, Status: 'Paid' } })

        if (newData?.length) {
          const latestEntry = newData.reduce((latest, current) =>
            new Date(current.payAmountDate) > new Date(latest.payAmountDate) ? current : latest);
          let newDate
          newDate = returnStartDate99(json, latestEntry);
          newData.push({
            ...jsonData, payAmountDate: newDate, payAmount: latestEntry.payAmount, paymentType: latestEntry.paymentType,
            Status: "Scheduled"
          });
        } else {
          let copy = { ...jsonData }; // clone the object
          copy.paymentType = 'Card';
          copy.Status = 'Scheduled';
          copy.payAmountDate = json?.installmentStartDate;
          copy.payAmount = json?.installmentAmount;
          newData.push(copy);
        }
        const sorted = [...(newData || [])].sort(
          (a, b) => new Date(a.payAmountDate) - new Date(b.payAmountDate)
        );

        // setTableData(sorted)
        return sorted;
      }






      if (totalInstalment > 0 && totalOccurrence !== 0 && isNotValidNullUndefile(totalOccurrence) && isNotValidNullUndefile(totalInstalment) && totalInstalment !== 0 && totalInstalment < 9999) {
        Array(totalInstalment).fill().forEach(() => newData.push({ ...jsonData }));
      }

      let payAmountHave = newData.filter((e) => { return e.payAmount == json.installmentAmount })?.map((e) => { return { ...e, Status: 'Paid' } })
      let startDate = new Date(json.installmentStartDate);
      let payAmountNothave = totalOccurrence > 0
        ?
        newData.filter(e => e.payAmount != json.installmentAmount).map((e, i) => ({
          ...e, payAmount: json.installmentAmount,
          Status: 'Scheduled', paymentType: 'Card', authSubInstallmentId: 0, orderId: null,
          payAmountDate: i === 0 ? startDate : returnStartDate(json, i)
        }))
        : [];



      if (payAmountHave.length > 0) {
        payAmountNothave.splice(0, payAmountHave.length); // Removes 2 items starting from index 0

      }


      let payAmountNotzero = newData.filter((e) => { return e.payAmount != null })?.map((e) => { return { ...e, Status: 'Paid' } })

      const finalJson = [...payAmountNotzero, ...payAmountNothave]
      const sorted = [...(finalJson || [])].sort(
        (a, b) => new Date(a.installmentStartDate) - new Date(b.installmentStartDate)
      );

      return sorted;

    } else {
      const totalPayAmount = json?.clientAuthInsVMs?.reduce((sum, item) => sum + (item.payAmount || 0), 0);
      if (isNotValidNullUndefile(json)) {
        const { totalAmount, totalDiscount } = json || {}
        const finalAmount = (totalAmount || 0) - (totalDiscount || 0) - (totalPayAmount || 0);
        // setRemaningAmout(finalAmount)
      }
      const jsonData =[...json?.clientAuthInsVMs]

      const payAmountData = jsonData?.map((e) => { return { ...e, Status: 'Paid' } })
      return payAmountData;
    }


  }
function formatUSNumber(amountStr) {
  const cleaned = String(amountStr).replace(/,/g, "");
  const n = parseFloat(cleaned);
  return isNaN(n)
    ? ""
    : n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}



    const setTableView = (header, mapTable, tableData,nextIndexs) => {

        setheader(header);
        setMapTable(mapTable);


        if(nextIndexs == 0){
          if (isNotValidNullUndefile(paymentTableData?.clientAuthSubsVMs)) {

            const data = [...paymentTableData.clientAuthSubsVMs]; // shallow copy (safe)
            const sorted = data.sort(
              (a, b) => new Date(a.installmentStartDate) - new Date(b.installmentStartDate)
            );
            const sortedData = sorted?.map((ele) => ({
              ...ele,
              clientAuthInsVMs: ele?.clientAuthInsVMs?.filter(
                (element) => element?.authSubInstallmentId !== 0
              ) || [],
            }));

            setTableData(sortedData)
        }

        }else{
          const sorted = [...(tableData || [])].sort(
              (a, b) => new Date(a.payAmountDate) - new Date(b.payAmountDate)
          );
          setTableData(sorted);
        }
    };

  const handleStep2Data = (json, index, newJson) => {
    const { clientAuthInsVMs, totalOccurrence, authSubscriptionId } = json
    if (isNotValidNullUndefile(authSubscriptionId)) {

      let totalInstalment = totalOccurrence
      let newData = [...json?.clientAuthInsVMs]
      let today = new Date();


      let jsonData = {
        "createdBy": null,
        "updatedBy": null,
        "createdOn": "0001-01-01T00:00:00",
        "updatedOn": "0001-01-01T00:00:00",
        "authSubInstallmentId": 0,
        "orderId": 0,
        "payAmount": null,
        "payAmountDate": null,
        "notes": null,
        "isActive": null,
        "Status": 'Paid'
      }
      if (totalOccurrence == 9999) {
        Array().fill().forEach(() => newData.push({ ...jsonData }));
        newData = newData.map((e) => { return { ...e, Status: 'Paid' } })

        if (newData?.length) {
          const latestEntry = newData.reduce((latest, current) =>
            new Date(current.payAmountDate) > new Date(latest.payAmountDate) ? current : latest);
          let newDate
          newDate = returnStartDate99(json, latestEntry);
          newData.push({
            ...jsonData, payAmountDate: newDate, payAmount: json.installmentAmount, paymentType: latestEntry.paymentType,
            Status: "Scheduled"
          });
        } else {
          let copy = { ...jsonData }; // clone the object
          copy.paymentType = 'Card';
          copy.Status = 'Scheduled';
          copy.payAmountDate = json?.installmentStartDate;
          copy.payAmount = json?.installmentAmount;
          newData.push(copy);
        }
        let sorted = [...(newData || [])].sort(
          (a, b) => new Date(a.payAmountDate) - new Date(b.payAmountDate)
        );
        
      // console.log(yearsFromNow(json.installmentStartDate),'yearsFromNowinstallmentStartDate')
      sorted = sorted
      for(let i=0; i<yearsFromNow(json.installmentStartDate); i++){
        let copy = { ...jsonData }; // clone the object
        let newInstallmentStartDate = new Date(json?.installmentStartDate);
         newInstallmentStartDate.setFullYear(newInstallmentStartDate.getFullYear() + i);

          copy.paymentType = 'Card';
          copy.Status = 'Not Paid';
          copy.payAmountDate = getFormattedDateForCE(newInstallmentStartDate);
          copy.payAmount = json?.installmentAmount;
          // newData.push(copy);
          if(newInstallmentStartDate < today){
          sorted.push(copy)
          }
      }

      sorted = [...(sorted || [])].sort(
          (a, b) => new Date(a.payAmountDate) - new Date(b.payAmountDate)
        );
      console.log(sorted,"sorted")
      
      // setTableData(sorted)
        return sorted;
      }
      if (totalInstalment > 0 && totalOccurrence !== 0 && isNotValidNullUndefile(totalOccurrence) && isNotValidNullUndefile(totalInstalment) && totalInstalment !== 0 && totalInstalment < 9999) {
        Array(totalInstalment).fill().forEach(() => newData.push({ ...jsonData }));
      }
      let startDate = new Date(json.installmentStartDate);
      let payAmountNothave = totalOccurrence > 0 ? newData.filter(e => e.authSubInstallmentId == 0).map((e, i) => ({
        ...e, payAmount: json.installmentAmount,
        Status: returnStartDate(json, i, 'addIndex') < today ? 'Not Paid' : 'Scheduled', paymentType: 'Card', authSubInstallmentId: 0, orderId: null,
        payAmountDate: i === 0 ? startDate : returnStartDate(json, i, 'addIndex')
      })) : [];
      const removeLenght = clientAuthInsVMs.filter((ele) => ele?.isScheduledPayment == true).length
      payAmountNothave = payAmountNothave.slice(removeLenght);

      let payAmountNotzero = newData.filter((e) => { return e.payAmount != null && e.authSubInstallmentId !== 0 })?.map((e) => { return { ...e, Status: 'Paid' } })
      const sorted = [...(payAmountNothave || [])].sort(
        (a, b) => new Date(a.installmentStartDate) - new Date(b.installmentStartDate)
      );
      const finalJson = [...payAmountNotzero, ...sorted]

      // setTableData(finalJson)
      return finalJson;

    } else {
      const totalPayAmount = json?.clientAuthInsVMs?.reduce((sum, item) => sum + (item.payAmount || 0), 0);
      if (isNotValidNullUndefile(json)) {
        const { totalAmount, totalDiscount } = json || {}
        const finalAmount = (totalAmount || 0) - (totalDiscount || 0) - (totalPayAmount || 0);
        // setRemaningAmout(finalAmount)
      }
         let jsonDatas = [{
        "createdBy": null,
        "updatedBy": null,
        "createdOn": "0001-01-01T00:00:00",
        "updatedOn": "0001-01-01T00:00:00",
        "authSubInstallmentId": 0,
        "orderId": 0,
        "payAmount": null,
        "payAmountDate": null,
        "notes": null,
        "isActive": null,
        "Status": '-',
        'paymentType': null
      }]

      const jsonData = [...json?.clientAuthInsVMs]
      const payAmountData = jsonData?.length > 0 ? json?.clientAuthInsVMs?.map((e) => { return { ...e, Status: 'Paid' } }) : jsonDatas

      return payAmountData;
    }

  };




  const returnToatlPay = (json, type) => {
    const totalPayAmount = json?.clientAuthInsVMs?.reduce((sum, item) => sum + (item.payAmount || 0), 0);
    let pendingAmount;

    if (isNotValidNullUndefile(json)) {
      const { totalAmount, totalDiscount } = json || {}
      const finalAmount = (totalAmount || 0) - (totalDiscount || 0) - (totalPayAmount || 0);
      pendingAmount = totalAmount > 0 ? finalAmount : 0

    }
    return type == "pending" ? `$${formatUSNumber(pendingAmount)}` : `$${totalPayAmount}`
  }

  const sharedStyle = {
    border: "1px solid rgb(222, 226, 230)",
    borderRadius: "5px",
    backgroundColor: "rgb(222, 226, 230)"
  }
  const renderFields = (fields) =>
    fields.map(({ label, value }) => (
      <div
        key={label}
        style={sharedStyle}
        className="my-auto w-full mb-2 md:mb-0"
      >
        {label}: {value ?? "-"}
      </div>
    ));


  function filterFields(fields) {
    return fields.filter(item => isNotValidNullUndefile(item.value) && item.value != '$0' && item.value !== '$null');
  }






        const getDayDifference = (d1, d2) =>
          Math.round((new Date(d1.getFullYear(), d1.getMonth(), d1.getDate()) - new Date(d2.getFullYear(), d2.getMonth(), d2.getDate())) / (1000 * 60 * 60 * 24));




    const isPositiveNumber = (value) => {
      return Number(value) >= 0;
    };






const funForOrderIdUpdate =async()=>{
//   await getUserdata(selectedUserData?.memberId)
  setFormData(json)
  setOrderIdData()
  setOpenModal(false)
  setisFuturePay(false)
  setRadioSections()
  setAdvancePay()
  setInstallmentData()
  setWeekDays()
  setPaymentType()
  setErrors()
}


useEffect(() => {
  if(openModal == false){
    funForOrderIdUpdate()
  }

}, [openModal])



const [upcomingPendingData,setUpcomingPendingData] = useState()
const [outStandingData,setoutStandingData] = useState()
const [todayData,setTodayData] = useState()
useEffect(() => {
  if(isNotValidNullUndefile(selectedUserData)){
       const pendingJson =  getDateDifferenceInDays(selectedUserData,"upcoming")
       const outStanding =  getDateDifferenceInDays(selectedUserData,"outStanding")
       const today =  getDateDifferenceInDays(selectedUserData,"today")
       setoutStandingData(outStanding)
       setTodayData(today)
       setUpcomingPendingData(pendingJson)
      //  console.log("fdlgjkfdsgldfkjl2222222",today)

      }

    }, [selectedUserData])



    function formatToUS(value) {
  const cleaned = String(value).replace(/,/g, "");
  const number = parseFloat(cleaned);
  return isNaN(number) ? "" : number.toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  });
}



















































const showBackButton =()=>{
   if(openModal == true || sepratepayment == true || payremaningModal == true || previewIndex == 1 || show == true){
    return true;
   }else{
    return false
   }
}

  function calculateAge(dobString) {

    if(!isNotValidNullUndefile(dobString)) return null
  const dob = new Date(dobString);
  const today = new Date();

  let age = today.getFullYear() - dob.getFullYear();
  const m = today.getMonth() - dob.getMonth();

  if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) {
    age--;
  }

  return age;
}



function getNextInstallmentInfo(data,index) {

  let nextTime;
  let nextAmount = null;
  if (data.totalOccurrence === 9999 && data.clientAuthInsVMs?.length) {

    const latest = data.clientAuthInsVMs.reduce((a, b) =>
      new Date(b.payAmountDate) > new Date(a.payAmountDate) ? b : a
    );

    const d = new Date(latest.payAmountDate);
    d.setFullYear(d.getFullYear() + 1);
    nextTime = d.getTime();
    nextAmount = latest.payAmount;

  } else if (data.totalOccurrence === 1 && data.clientAuthInsVMs.length === 0) {
    const d = new Date(data.installmentStartDate);
    nextTime = d.getTime();
    nextAmount = data.installmentAmount;
  } else {
    // nextTime = start.getTime() + (parseInt(data.authLength, 10) || 0) * 24 * 60 * 60 * 1000;
    nextTime = returnStartDate(data,index);

    nextAmount = data.installmentAmount;
  }

  // 5) Format date as MM/DD/YYYY
  const nd = new Date(nextTime);
  const mm = String(nd.getMonth() + 1).padStart(2, '0');
  const dd = String(nd.getDate()).padStart(2, '0');
  const yyyy = nd.getFullYear();
  const nextDate = `${mm}/${dd}/${yyyy}`;

  return { nextDate, nextAmount };
}
function getDateDifferenceInDays(data,type) {

    const json = data?.clientAuthSubsVMs?.filter((element) => element?.totalOccurrence !== null)?.map((ele, index) => {
      if (type == "today") {
        const { nextDate, nextAmount } = getNextInstallmentInfo(ele, index);
        const d1 = new Date(nextDate);
        const d2 = new Date();
        d1.setHours(0, 0, 0, 0);
        d2.setHours(0, 0, 0, 0);
        const diffMs = d1 - d2;
        const diffDays = diffMs / (1000 * 60 * 60 * 24);

      // console.log("djhfadsgfdjgfdjgfd",diffDays,d1,ele)

        return { "days": diffDays, "amount": nextAmount };
      }else if(type == 'outStanding'){






      }else {
        const paidIns = createIntalments(ele).filter((ele) => ele?.authSubInstallmentId == 0)

        return { "totalInstallment": paidIns.length > 0 ? 1 : 0, "pending": paidIns?.length > 0 ? ele?.installmentAmount : 0 };

      }


    })

    if (type == "today") {
      const filteredDatas = json.filter(item => item?.days == 0)
      const totalAmount = filteredDatas.reduce((sum, { amount }) => sum + amount, 0);
            // console.log("fdlkgfsdlgjldfkgjkld",json)
      return { "length": filteredDatas.length, "amount": totalAmount }
    }else if(type == 'outStanding'){
        let totalAmounts = 0;
        let totalDiscount = 0;
        let totalPay = 0;
        let length = 0

          //  data?.clientAuthSubsVMs?.filter((element) => element?.totalOccurrence !== null)?.forEach((ele) => {
           data?.clientAuthSubsVMs?.forEach((ele) => {
           const filterJsonData = Array.isArray(ele?.clientAuthInsVMs) ? ele.clientAuthInsVMs.filter(item => item?.authSubInstallmentId != 0) : [];

            const totalPayAmounts = filterJsonData.reduce((sum, item) => {
              return sum + Number(item?.payAmount || 0);
            }, 0);
            totalAmounts += Number(ele?.totalAmount || 0);
            totalDiscount += Number(ele?.totalDiscount || 0);
            totalPay += totalPayAmounts;
            if(!(ele?.totalAmount == ((totalPayAmounts || 0) + (ele?.totalDiscount || 0)))){
              length += 1;
              // console.log("dflkjfdlkgjldfkg",ele)
            }
          });

        const result = {
          totalAmounts: totalAmounts.toFixed(2),
          totalDiscount: totalDiscount.toFixed(2),
          netOutstanding: (totalAmounts - totalDiscount - totalPay).toFixed(2),
          totalPayment: totalPay.toFixed(2),
          length : length
        };
        return result
    }else {
      const totalAmount = json.reduce((sum, { pending }) => sum + pending, 0).toFixed(2);
      const totalInstallments = json.reduce((sum, { totalInstallment }) => sum + totalInstallment, 0);
      return { "length": totalInstallments, "amount": totalAmount }
    }



}

  const cellStyle = { padding: "7px", borderBottom: "1px solid #111318ff", fontFamily: 'Roboto', fontWeight: 400, color: '#6B7280', background: 'white', fontSize:'14px',margin:'0px',height:'0px' };
    const headerStyle = {
    borderBottom: "1px solid #111318ff",
    paddingLeft: "5px",
    backgroundColor: "#FAFBFC", // optional: improves visual clarity
    fontWeight: 600,         // optional: adds emphasis
    color: "#1A1B1C",
    fontFamily: 'Roboto',
    marginLeft: '2px',
    fontSize:'15px'
  };
    const getPaymentType = (ele) => {
  if (ele?.paymentType == 1 || ele?.paymentType == "Card") {
    return "Card";
  }
  if (!isNotValidNullUndefile(ele?.paymentType)) {
    return "-";
  }
  if (isNotValidNullUndefile(ele?.authSubInstallmentId)) {
    return ele?.paymentType;
  }
  return "Cash";
};



function yearsFromNow(dateString) {
  const start = new Date(dateString);
  const now = new Date();

  let years = now.getFullYear() - start.getFullYear();

  // Adjust if the current date hasn't reached the month/day yet
  const hasNotReached =
    now.getMonth() < start.getMonth() ||
    (now.getMonth() === start.getMonth() && now.getDate() < start.getDate());

  if (hasNotReached) {
    years--;
  }

  return years > 0 ? years : 1;
}



    return (
        <>
            <div>



                <div className="flex justify-between items-start mb-4">

                    <div className="p-3 rounded-[9px] shadow-md ms-2 me-2"style={{ border: '1.5px solid #D7D7D7',width:"100%"}}>
                        <div className='d-flex' style={{display:"flex"}}>
                           {showBackButton() && (
                        <div className="flex items-center rounded-[7px] shadow-md cursor-pointer me-3" style={{ padding: "0.5rem" }} onClick={() => handleChange("", "no", "", "")}>
                            <img className="w-[10px]" src="/back.svg" alt="Back" />
                        </div>)}

                        <h4 style={{ fontSize: "16px", fontWeight: "700" }}>{selectedUserData?.fullName || selectedUserData?.memberName} : <span style={{ fontWeight: "400" }}>{selectedUserData?.matNo || '-'}</span> </h4>

                        </div>
                        <div className='' style={{ fontFamily: 'Roboto',display:'flex', justifyContent: "space-around",width:"100%" }}  >
                            <div className="mt-0" style={{ width: '400px' }}>
                                <div className="text-center" style={{ display: "flex" }}>
                                    <div className=''>
                                        <div className="me-2">
                                            <img src={selectedUserData?.profileURL ?? "/dummyuser.svg"} className="" style={{height:"7rem"}}/>
                                        </div>

                                    </div>
                                    <div className='mt-auto mb-5'>
                                        <p className='flex'><img className='me-1' src={"/userProfile.svg"} /> Age : {calculateAge(selectedUserData?.memberDOB) || '-'}</p>
                                        <p className='flex'>
                                            <img className='me-1 mb-auto' style={{ marginLeft: "2px",marginTop:"5px" }} src="/location.svg" />
                                             <span className='text-start ms-1'>
                                             {selectedUserData?.memberAddress || 'N/A'}
                                             </span>
                                             </p>



                                    </div>

                                </div>
                            </div>
                            <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 mb-2 mt-1 mx-3' style={{display:"flex"}}>
                            <div className="mt-0" style={{ width: '240px' }}>
                                <div className="text-center p-2 rounded-[9px] shadow-md" style={{ border: '1.5px solid #D7D7D7', display: "flex" }}>
                                    <div className='p-1 pe-2'>
                                        <div className="flex items-center justify-center rounded-full text-[16px]" style={{ background: '#FF8B001A' }}>
                                            <img src="/notes.svg" className="p-2 m-0" />
                                        </div>

                                    </div>
                                    <div className=''>
                                        <h4 className="flex items-center justify-center gap-3 mb-0 pb-0 font-bold text-md text-gray-800">
                                            {"Pending Payment Today"}
                                        </h4>
                                        <p className="text-sm mt-0" style={{ color: "#7C7C7C" }}>{isNotValidNullUndefile(todayData) && todayData.length} Invoices</p>
                                        <p className="font-bold text-lg mt-0">${isNotValidNullUndefile(todayData) && formatToUS(todayData.amount) || 0}</p>

                                    </div>


                                </div>
                            </div>
                            <div className="mt-0" style={{ width: '280px' }}>
                                <div className="text-center p-2 rounded-[9px] shadow-md" style={{ border: '1.5px solid #D7D7D7', display: "flex" }}>
                                    <div className='p-1 pe-2'>
                                        <div className="flex items-center justify-center rounded-full text-[16px]" style={{ background: '#FF8B001A' }}>
                                            <img src="/upcoming.svg" className="p-2 m-0" />
                                        </div>

                                    </div>
                                    <div className=''>
                                        <h4 className="flex items-center justify-center gap-3 mb-0 pb-0 font-bold text-md text-gray-800">
                                            {"Upcoming Scheduled Payment"}
                                        </h4>
                                        <p className="text-sm mt-0" style={{ color: "#7C7C7C" }}>{isNotValidNullUndefile(upcomingPendingData) && upcomingPendingData.length || 0} Invoices</p>
                                        <p className="font-bold text-lg mt-0">${isNotValidNullUndefile(upcomingPendingData) && formatToUS(upcomingPendingData.amount) || 0}</p>

                                    </div>


                                </div>
                            </div>

                            <div className="mt-0" style={{ width: '240px' }}>
                                <div className="text-center p-2 rounded-[9px] shadow-md" style={{ border: '1.5px solid #D7D7D7', display: "flex" }}>
                                    <div className='p-1 pe-2'>
                                        <div className="flex items-center justify-center rounded-full text-[16px]" style={{ background: '#FF8B001A' }}>
                                            <img src="/outStanding.svg" className="p-2 m-0" />
                                        </div>

                                    </div>
                                    <div className=''>
                                        <h4 className="flex items-center justify-center gap-3 mb-0 pb-0 font-bold text-md text-gray-800">
                                            {"Total Outstanding"}
                                        </h4>
                                        <p className="text-sm mt-0" style={{ color: "#7C7C7C" }}>{isNotValidNullUndefile(outStandingData) && outStandingData?.length || 0} Invoices</p>
                                        <p className="font-bold text-lg mt-0">${isNotValidNullUndefile(outStandingData) && formatToUS(outStandingData?.netOutstanding) || 0}</p>

                                    </div>


                                </div>
                            </div>
                            </div>
                        </div>

                    </div>


                </div>

                <div className="mt-4 overflow-x-auto rounded-lg font-sans" style={{ paddingLeft:"4px",paddingRight:"4px",paddingBottom:"4px", borderRadius: "5px", maxHeight: "25rem", overflowY: "auto",border:"1px solid #111318ff" }}>


                   <table className="table w-full" style={{ marginBottom: 0, height: '60vh' }}>
                                <thead className="sticky-header" style={{ position: "sticky", top: "0", background: "white", zIndex: "1" }}>
                                  <tr>
                                    {header?.map((text, index) => (
                                      <th key={index} style={headerStyle} className="py-[7px]">
                                        <div className="flex justify-between">
                                         {`${text}`}
                                        </div>
                                      </th>
                                    ))}
                                  </tr>
                                </thead>
                               <tbody>
                                {/* {console.log(tableData,"tableDatatableData")} */}
                                  {tableData?.length > 0 &&
                                    tableData.map((client, index) => {
                                      const newTable = handleStep2Data(client) || [];
                                      const listLength = newTable.length;
                                      // console.log(client,"clientclient",newTable)
                                      // console.log(yearsFromNow(client.installmentStartDate),"clientclientyearsFromNow")
                                      return (
                                        newTable?.length > 0 &&
                                        newTable?.map((ele, clientIndex) => {
                                        let accountTypearray = (ele?.accountType != null || ele?.accountType != undefined) ? JSON?.parse(ele?.accountType) : [];
                                        let generalAmount = (![7,9,5].includes(ele?.paymentTypeId) && accountTypearray?.length == 0) ? formatUSNumber(ele?.payAmount) : formatUSNumber(accountTypearray?.find((a)=> a?.AccountTypeId == 1)?.Amount);
                                        let ioltaAmount = accountTypearray?.find((a)=> a?.AccountTypeId == 2)?.Amount;
                                        let showgeneral = accountTypearray?.some((a)=> a?.AccountTypeId == 1)
                                        let showiolta = accountTypearray?.some((a)=> a?.AccountTypeId == 2)
                                        // console.log(accountTypearray,"accountTypearrayaccountTypearray",ele)
                                        // console.log(client,"clientclientclient",paymentTableData)
                                          return<tr key={`${index}-${clientIndex}`} style={cellStyle}>
                                            {clientIndex == 0 && (
                                              <>
                                                <td rowSpan={listLength} style={cellStyle}>
                                                  {client?.serviceMatNo || paymentTableData?.matNo || '-'}<br/>
                                                    <span>Date - {getFormattedUTCDateForCE(client?.userSubsCreatedOn)}</span>

                                                </td>
                                                <td rowSpan={listLength} style={cellStyle}>
                                                  {client?.originatingAttorneyName || paymentTableData?.originatingAttorneyName || '-'} / {client?.responsibleAttorneyName || paymentTableData?.responsibleAttorneyName || '-'}
                                                </td>

                                                <td rowSpan={listLength} style={cellStyle}>
                                                  {client?.subscriptionName || '-'}
                                                </td>

                                                <td rowSpan={listLength} style={cellStyle}>
                                                  {(client?.sourceTypeId == '999999' ? client?.sourceOtherValue : client.sourceType) || '-'}
                                                </td>
                                                <td rowSpan={listLength} style={cellStyle}>
                                                  {`$${formatUSNumber(client?.totalAmount)}`}
                                                </td>
                                                   <td rowSpan={listLength} style={cellStyle}>
                                                  {returnToatlPay(client,'pending') > 0 ? returnToatlPay(client,'pending')  : '$0.00'}
                                                </td>
                                              </>
                                            )}

                                            <td style={cellStyle}>{isNotValidNullUndefile(ele?.payAmount) ? `${ele?.isRefund == true ? '-' : ''}$${formatUSNumber(ele?.payAmount)}` : '-'}</td>
                                            <td style={cellStyle}><p className="d-flex">{(isNotValidNullUndefile(generalAmount)) ? <p>{ele?.isRefund == true ? '-' : ''}${generalAmount}(General){accountTypearray?.length == 2 ? '|' :''}</p> : '-'}
                                            {showiolta ? <p>  {ele?.isRefund == true ? '-' : ''}${formatUSNumber(ioltaAmount)}(IOLTA) </p> : null }</p></td>
                                            <td style={cellStyle}>{isNotValidNullUndefile(ele?.payAmountDate) ? ele?.isScheduledPayment == true ? getFormattedDateForCE(ele?.payAmountDate) : getFormattedUTCDateForCE(ele?.payAmountDate) : '-' || '-'} </td>
                                            <td style={cellStyle}>{ele?.Status === "Scheduled" && ["Cash", "Check", "ACH", "Ach/Wire"].includes(ele?.paymentType) ? "Card" : getPaymentType(ele)}</td>
                                            <td style={cellStyle}>{ele?.isRefund == true ? 'Refund' : (ele?.Status || '-')}</td>
                                            <td style={cellStyle}>{isNotValidNullUndefile(ele?.notes) && ele?.notes != 'null' ? ele?.notes : '-'  || '-'}</td>
                                          </tr>
                                        }
                                        )
                                      );
                                    })}
                                </tbody>
                    </table>
                </div>
            </div>
        </>
    );
};

export default CommonTable;